import { render, staticRenderFns } from "./WarehouseReceiptStock.vue?vue&type=template&id=2d72dbb8&scoped=true&"
import script from "./WarehouseReceiptStock.vue?vue&type=script&lang=js&"
export * from "./WarehouseReceiptStock.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseReceiptStock.vue?vue&type=style&index=0&id=2d72dbb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72dbb8",
  null
  
)

export default component.exports